<template>
    <trax-ui-top-box :background-image="phase.meta.background" 
        :icon="learning_unit_icons[item.type]" :title1="item.code" 
        :title2="phase.name" :title3="registration.program.name" 
        :description-title="item.name" 
        :description="item.description" description-toggle="1" description-hidden="1"
        :button-icon="buttonIcon" :button-name="buttonName" :button-handler="buttonHandler" 
        :link1="group" :link2="date" :link3="location" 
        :user-name="userName" :user-picture="userPicture">
    </trax-ui-top-box>
</template>

<script>
    export default {

        props: {
            editButton: null,
            viewButton: null,
        },

        data() {
            return {
                lang: lang,
                state: data.state,
                user: user,
                registration: data.registration,
                phase: data.phase,
                item: data.item,
                learner: data.learner,
                learning_unit_dashboard_routes: data.learning_unit_dashboard_routes,
                locations_names_uuid: data.locations_names_uuid,
                learning_unit_icons: data.learning_unit_icons
            }
        },

        computed: {

            buttonIcon() {
                if (this.viewButton) return 'bar_chart';
                if (this.editButton && this.editDashboardPermission && this.stateAllowsEdition) return 'edit';
            },

            buttonName() {
                if (this.viewButton) return this.lang.polaris.dashboard.display;
                if (this.editButton && this.editDashboardPermission && this.stateAllowsEdition) return this.lang.polaris.form.edit;
            },

            buttonHandler() {
                if (this.viewButton) return this.viewHandler;
                if (this.editButton && this.editDashboardPermission && this.stateAllowsEdition) return this.editHandler;
            },

            stateAllowsEdition() {
                // An archived registration is closed: its sheets are read-only.
                if (this.registration.status == 'archived') {
                    return false
                }
                if (!this.state) {
                    return true
                }
                if (!this.state.validation) {
                    return true
                }
                return false
            },

            editDashboardPermission() {
                return this.user.admin || this.user.permissions['dashboard.write-all'] || this.user.permissions['dashboard.write-mine-locations'];
            },

            userName() {
                return this.learner.lastname + ' ' + this.learner.firstname;
            },

            userPicture() {
                return this.learner.avatar;
            },

            group() {
                var link = {value: this.registration.cohort.name, icon: 'people'};
                var routes = this.learning_unit_dashboard_routes;
                var href = routes[this.item.type]+'/registration/'+this.registration.id+'/'+this.item.type+'/'+this.item.id;
                if (this.collectiveDashboardPermission) link.href = href;
                return link;
            },

            date() {
                if (!this.state || !this.state.date) return null;
                return {value: moment(this.state.date).format('DD MMM YYYY'), icon: 'event'};
            },

            location() {
                if (!this.state || !this.state.location) return null;
                var name = this.locations_names_uuid[this.state.location.entity_uuid];
                if (!name) name = this.state.location.entity_name;
                return {value: name, icon: 'location_on'};
            },

            collectiveDashboardPermission() {
                if (this.item.user_id) {
                    // This is a custom individual item. Don't go to collective report.
                    return false;
                }
                return this.user.admin || this.user.permissions['dashboard.read-all'] || this.user.permissions['dashboard.read-mine-locations']
                    || this.user.permissions['dashboard.read-mine-collaborators'] || this.user.permissions['dashboard.write-all']
                    || this.user.permissions['dashboard.write-mine-locations'] || this.user.permissions['registration.manage'];
            }
        },

        methods: {

            editHandler() {
                var routes = this.learning_unit_dashboard_routes;
                var href = routes[this.item.type]+'/registration/'+this.registration.id+'/'+this.item.type+'/'+this.item.id;
                href += '/learner/'+this.learner.id+'/edit';
                window.location = href;
            },

            viewHandler() {
                var routes = this.learning_unit_dashboard_routes;
                var href = routes[this.item.type]+'/registration/'+this.registration.id+'/'+this.item.type+'/'+this.item.id;
                href += '/learner/'+this.learner.id;
                window.location = href;
            }
        }

    }
</script>
